import { analytics } from '@/fireinit';

export default {
    install(Vue, options) {

        // 3. add an instance method
        Vue.prototype.$analytics = analytics
    }

}